module.exports = __webpack_public_path__ + "static/media/alert-sign@2x.c7fe64c2.png";